// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tab_wrapper__URYdP","tabs":"Tab_tabs__uDJpM","tab":"Tab_tab__U-1QA","active":"Tab_active__2M-M0","load":"Tab_load__2v6Pj"};